import React from 'react';
import { Beers } from '../../components/Beers';
import { Search } from '../../components/Search';

export const Product = () => {
  return (
    <>
      <Search />
      <Beers />
    </>
  );
};
